import React from 'react';
import { Icon } from './Icon.js';
export const IconLoader3Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("circle", { cx: "9", cy: "3", r: "2", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("circle", { cx: "3.8038", cy: "6", r: "2", opacity: ".2", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("circle", { cx: "3.8038", cy: "12", r: "2", opacity: ".36", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("circle", { cx: "9", cy: "15", r: "2", opacity: ".52", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("circle", { cx: "14.1962", cy: "12", r: "2", opacity: ".68", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("circle", { cx: "14.1962", cy: "6", r: "2", opacity: ".84", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconLoader3Fill18.js.map